<template>
    <ModeSwitcher
        ref="modeSwitcher"
        :main-mode-text="$t('create')"
        :create-mode-text="$t('create_discount')"
        :edit-mode-text="$t('edit_discount')"
        class="pt-4"
        @reset="resetData"
    >
        <template v-slot:btn-block>
            <div class="full-width d-flex align-center">
                <v-spacer />
                <FilterStatusToggle v-model="activeFilter" @update:model-value="loadData" />
            </div>
        </template>
        <template v-slot:main-mode>
            <v-data-table
                :headers="useHeaders"
                :items="discounts"
                :items-per-page-options="useTableOptions(discounts.length)"
                :items-length="discounts.length"
                density="compact"
                class="elevation-1 table-server"
                must-sort
                fixed-header
                :loading="isLoading"
            >
                <template v-slot:item.name="{item}">
                    <span class="text-link" @click="editSalesSettings(item.id)">
                        {{ item.name }}
                    </span>
                </template>
                <template v-slot:item.active="{item}">
                    {{ item.active ? $t('active') : $t('inactive') }}
                </template>
                <template v-slot:item.actions="{item}">
                    <v-btn variant="text" size="small" @click="copyDiscount(item.id)">
                        {{ $t('copy') }}
                    </v-btn>
                </template>
            </v-data-table>
        </template>
        <template v-slot:additional-mode>
            <DiscountsAndPromotionsForm
                :discount-id="selectedDiscountId"
                :cory-discount-id="coryDiscountId"
                @save="save()"
                @cancel="modeSwitcher.goToTable()"
            />
        </template>
    </ModeSwitcher>
</template>

<script setup lang="ts">
    const isLoading = ref<boolean>(false)
    const selectedDiscountId = ref<number>()
    const coryDiscountId = ref<number>()
    const modeSwitcher = ref(null)
    const activeFilter = ref<boolean>(true)
    const discounts = ref<any[]>([])

    const {$api, $toast} = useNuxtApp()
    const {t} = useI18n()

    onMounted(async () => {
        await loadData()
    })

    async function loadData(): Promise<void> {
        isLoading.value = true
        try {
            discounts.value = (await $api.discounts.get({active: activeFilter.value})).discounts
        } catch (e) {
            $toast.error(t('error_message.load_error'))
        } finally {
            isLoading.value = false
        }
    }

    const useHeaders = computed(() => {
        return [
            {title: t('discount_name'), value: 'name', minWidth: '150px', sortable: true},
            {title: t('promocode'), value: 'promoCode'},
            {title: t('status'), value: 'active', width: '140px'},
            {title: t('actions'), value: 'actions', align: 'end'},
        ]
    })

    const resetData = (): void => {
        selectedDiscountId.value = null
        coryDiscountId.value = null
    }

    const editSalesSettings = (id: number): void => {
        selectedDiscountId.value = id
        modeSwitcher.value.edit()
    }

    const copyDiscount = (id: number): void => {
        coryDiscountId.value = id
        modeSwitcher.value.create()
    }

    const save = async (): Promise<void> => {
        modeSwitcher.value.goToTable()
        await loadData()
    }
</script>
